(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vbb-main-footer"]) return;
  try {
    
window.addEventListener('DOMContentLoaded', () => {
  const toggleButtons = document.querySelectorAll('.vbb-main-footer__core__link-lists button');

  toggleButtons.forEach(toggleButton => toggleButton.addEventListener('click', e => {
    e.target.closest('nav').classList.toggle('active');
  }));
});

  } catch(e) { console.error(e); }
})();
})();
